let axios = function ({ methods = "post", url = "", data = {}, headers = {}, responseType = {} } = {}) {
  let resetUrl = `${url}`
  switch (methods) {
    case 'put':
    case 'post':
      return $axios[methods](resetUrl, data, headers, responseType);
    case 'delete':
    case 'get':
      return $axios[methods](`${resetUrl}`, { params: data }, headers, responseType);
  }
};

import $axios from './http.js'

export default axios;
